import PropTypes from 'prop-types';
import {Form} from 'semantic-ui-react';
import EditableTitle from './EditableTitle';

export function OptionalAddressTitle({
  className,
  title1,
  title2,
  updateAddressLine1,
  updateAddressLine2,
  isEnabled,
  label,
  maxLength,
  placeholder,
}) {

  const toggleIsEnabled = () => {
     updateAddressLine1({isEnabled: !isEnabled});
     updateAddressLine2({isEnabled: !isEnabled});
  };

  return (
    <Form.Group inline className={className}>
      <div>
        <Form.Checkbox checked={isEnabled} inline label={label} onChange={toggleIsEnabled}/>
        <EditableTitle title={title1}
                       placeholder={placeholder}
                       maxLength={maxLength}
                       isEnabled={isEnabled}
                       onUpdateData={updateAddressLine1}
                       className={`${className}1`}
        />
      </div>
      <div className="address-line2">
        {!label && <Form.Checkbox className="indenter" style={{opacity: 0}} inline/>}
        <EditableTitle title={title2}
                       placeholder={placeholder}
                       maxLength={maxLength}
                       isEnabled={isEnabled}
                       onUpdateData={updateAddressLine2}
                       className={`${className}2`}
        />
      </div>
    </Form.Group>
  );
}
OptionalAddressTitle.propTypes = {
  className: PropTypes.string.isRequired,
  title1: PropTypes.string,
  title2: PropTypes.string,
  updateAddressLine1: PropTypes.func,
  updateAddressLine2: PropTypes.func,
  isEnabled: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
};